import { useQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { useWishlistId } from "@grandvisionhq/svc-wishlist";
import GET_MY_WISHLIST_ID from "../../operations/queries/operations/queries/get-my-wishlist-id.js";
const useGetMyWishlistId = () => {
  const { locale } = useIntl();
  const { data, loading, error, refetch } = useQuery(GET_MY_WISHLIST_ID, {
    context: {
      forwardHeaders: {
        "Accept-Language": locale
      }
    }
  });
  useWishlistId(refetch);
  return {
    id: data?.me?.wishlist?.id ?? void 0,
    loading,
    error: error || null
  };
};
export {
  useGetMyWishlistId
};
//# sourceMappingURL=use-get-my-wishlist-id.js.map
